export interface FeatureFlagResponse {
  created: string;
  modified: string;
  name: FeatureFlagName;
  project: string;
  toggleActive: boolean;
}

export enum FeatureFlagName {
  RSU_SUPPORT = 'rsu_support',
  REFERRAL_CODE = 'referral_code',
  /** Mirrors advisor-experience's flag of the same name (HWEPD-10406). */
  QUESTIONNAIRE_TASK = 'questionnaire_task_type',
  /** New client portal homepage (HWEPD-10407). Off → legacy Tasks & Engagements page. */
  CLIENT_PORTAL_HOME_V2 = 'client_portal_home_v2',
}

export interface FeatureFlags {
  rsuSupport: boolean;
  referralCode: boolean;
  questionnaireTask: boolean;
  clientPortalHomeV2: boolean;
}
